import React from "react"

import { Card, Row, Col } from "react-bootstrap"

function OpeningHours() {
    return (
        <Card className="p-0 mt-4 ms-lg-auto">
            <Card.Body>
                <Row>
                    <Col xs={6}>
                        <span>Monday</span>
                    </Col>

                    <Col xs={6} className="text-end">
                        <span>09:00-17:00</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <span>Tuesday</span>
                    </Col>

                    <Col xs={6} className="text-end">
                        <span>09:00-17:00</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <span>Wednesday</span>
                    </Col>

                    <Col xs={6} className="text-end">
                        <span>09:00-17:00</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <span>Thursday</span>
                    </Col>

                    <Col xs={6} className="text-end">
                        <span>09:00-17:00</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <span>Friday</span>
                    </Col>

                    <Col xs={6} className="text-end">
                        <span>09:00-17:00</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <span>Saturday</span>
                    </Col>

                    <Col xs={6} className="text-end">
                        <span>09:00-14:00</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <span>Sunday</span>
                    </Col>

                    <Col xs={6} className="text-end">
                        <span>Closed</span>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default OpeningHours
